import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { PrepareIeltsExam } from "@modules/elearning/lead";

const PrepareForIeltsExam = () => {
  return (
    <LayoutMain
      title="How to Prepare for Your IELTS Exam"
      footer_with_evaluation
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/elearning/prepare-for-ielts-exam`}
    >
      <PrepareIeltsExam />
    </LayoutMain>
  );
};

export default PrepareForIeltsExam;
